module.exports = __webpack_public_path__ + "fonts/baronsans-bolditalic-webfont.d77c9f6e.woff2";